// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Suspense } from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '~/locales';
import Loading from './components/Loading';
import { AppProvider } from './hooks';
import Routes from './routes/app.routes';

import GlobalStyles from './styles/global';

const App = () => {
  return (
    <>
      <AppProvider>
        <Suspense fallback={<p>Carregando...</p>}>
          <Loading />
          <GlobalStyles />
          <ToastContainer hideProgressBar autoClose={2000} />
          <Routes />
        </Suspense>
      </AppProvider>
    </>
  );
};

export default App;
